<template>
  <iframe id="swbc-buy-now"></iframe>
</template>
<script>
  const SwbcSales = window.SwbcSales
  import QuoteExample from './quoteExample.js'
  export default {
    name: 'Simple',
    mounted () {
      const frame = this.$el
      const SWBC = new SwbcSales({
        mode: 'selection',
        element: frame,
        origin: 'https://web.devmktapp.com',
        institution: '9a175661-f00d-4697-9b6e-f80bb4a06964'
      })
      SWBC.init(() => {
        SWBC.send('quote', QuoteExample())
        SWBC.on('reservation', (reservation) => {
          alert(JSON.stringify(reservation, null, 2))
        })
      })
    }
  }
</script>
<style>
  #swbc-buy-now {
    height: 800px;
    width: 800px;
    border: none;
  }
</style>
